export const TAB_ALL = 0;
export const TAB_NOTICE = 1;
export const TAB_BANNER = 2;
export const TAB_OTHER = 3;
export const HAS_NEW_ICON = 1;
